import { Injectable, inject } from '@angular/core'

import { Store } from '@ngrx/store'

import { Observable, of } from 'rxjs'

import { AiAnalystService } from './ai-analyst.service'
import { AiDesignerService } from './ai-designer.service'
import { AiSelectors } from './ai.selectors'

import { AiAgent, DocumentContextReference } from '../types/ai.types'

@Injectable({
  providedIn: 'root',
})
export class AiService {
  #store = inject(Store)
  #aiAnalystService = inject(AiAnalystService)
  #aiDesignerService = inject(AiDesignerService)

  generateFromDocument(documentContextReference: DocumentContextReference): Observable<any> {
    const selectedAgent = this.#store.selectSignal(AiSelectors.selectedAgent)()

    if (!selectedAgent) {
      return of(null)
    }

    switch (selectedAgent) {
      case AiAgent.ANALYST:
        return this.#aiAnalystService.generateFromDocument(documentContextReference)
      case AiAgent.DESIGNER:
        return this.#aiDesignerService.generateFromDocument(documentContextReference)
    }
  }
}
